export default __webpack_public_path__ + "static/media/profile-img.0dde0007.png";